import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';

const MttSchemaList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getMttSchemaData } = useService();
	return (
		<DataList
			fetchData={getMttSchemaData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.MTT_SCHEMA}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default MttSchemaList;
